<script setup lang="ts">
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/LeftTitleAndText'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 px-2xl flex flex-col gap-7.5 xl:max-w-7/10"
    >
      <span class="text-H1 text-Tekst">
        <CmsText
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'tekst_1']"
        />
      </span>
      <span class="text-Tekst text-H4">
        <CmsText
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'tekst_2']"
        />
      </span>
    </div>
  </CmsCustomComponent>
</template>
